"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var baseDealerLayoutStyles = styles_1.makeStyles(function (_a) {
    var _b;
    var breakpoints = _a.breakpoints;
    return ({
        layoutContainer: (_b = {
                display: 'flex',
                width: '100%',
                flexWrap: 'wrap',
                overflow: 'hidden',
                justifyContent: 'center',
                alignItems: 'center'
            },
            _b[breakpoints.down('sm')] = {
                padding: '0 15px',
            },
            _b),
    });
}, { name: 'Common_BaseDealerLayout' });
exports.default = baseDealerLayoutStyles;
